import React, {useCallback, useEffect, useState} from "react"
import Select from 'react-select';
import styles from "../css/Text.module.css";

interface Props {
    options: Array<{ value: string, label: string }>,
    placeholder?: string,
    onChange?: Function
    menuPlacement?: "auto" | "bottom" | "top",
    label?: string,
    id?: string,
    isSearchable?: boolean,
    isClearable?: boolean,
    hint?: string,
    formatOptionLabel?: (option: any) => React.ReactNode,
    SingleValue?: any,
    value?: Option | Array<Option>,
    defaultValue?: Option | Array<Option>,
    readonly?: boolean
    isMulti?: boolean,
    onTryingToRemoveFixedOption?: Function
}

export interface Option {
    value: string,
    label: string
}

export default (props: Props) => {

    // Props

    const {
        menuPlacement = 'auto',
        isMulti,
        formatOptionLabel,
        SingleValue,
        id,
        readonly,
        onChange,
        defaultValue,
        isSearchable,
        options,
        placeholder,
        label,
        hint,
        value,
        isClearable = false,
        onTryingToRemoveFixedOption
    } = props;

    // State

    const selectDefaultOption:any = value || defaultValue;
    const [selectedOption, setSelectedOption] = useState(isMulti ? [selectDefaultOption] : selectDefaultOption);

    // Callbacks

    const handleChange = useCallback(
        (option, { removedValue }) => {
            if (removedValue && removedValue.fixed) {
                onTryingToRemoveFixedOption && onTryingToRemoveFixedOption();
                return;
            }
            setSelectedOption(option);
            if (isMulti) {
                onChange && onChange(option ? option.map(({value}: any) => value) : [])
            } else {
                onChange && onChange(option ? option.value : '')
            }
        },
        [onChange, isMulti, onTryingToRemoveFixedOption],
    );

    // Effects

    useEffect(() => {
        setSelectedOption(value)
    }, [value]);

    // Configuration

    const configuredStyle = {
        multiValueRemove: (base: any, state: any) => {
            return state.data.fixed ? { ...base, display: 'none' } : base;
        },
    };

    return (
        <>
            {label ? <label htmlFor={id} className={styles.label}>{label}</label> : null}
            <Select
                onFocus={() => {
                    setTimeout(() => {
                        window.scrollTo(0, 200)
                    }, 300)
                }}
                styles={configuredStyle}
                isDisabled={readonly}
                isMulti={isMulti}
                backspaceRemovesValue
                getOptionValue={(o: any) => {
                    return o.value || "All";
                }}
                id={id}
                formatOptionLabel={formatOptionLabel}
                menuPlacement={menuPlacement}
                components={SingleValue ? {SingleValue, MultiValueLabel: SingleValue} : undefined}
                className={`selectInputContainer ${isMulti ? "multiSelectInput" : ""}`}
                defaultValue={defaultValue}
                classNamePrefix="selectInput" // this a prefix
                placeholder={placeholder}
                isClearable={isClearable}
                isSearchable={!!isSearchable}
                value={selectedOption}
                onChange={handleChange}
                options={options}
            />
            {hint ? <label htmlFor={id} className={styles.hint}>{hint}</label> : null}
        </>
    )
}
